export const LOADING_PAGE_NOTFOUND = 'LOADING_PAGE_NOTFOUND';
